import { connect } from 'react-redux';
import { getHashVars } from '../../../../../../../shared/frontend/libs/utils';
import { FeatureFlag } from '../../../../../../../shared/gameConfig/sharedTypes';
import {
  TKeystoneRunRankingsTablePropsFromState,
  TKeystoneRunRankingsTableOwnProps
} from './types';
import { KeystoneRunRankingsTableBase } from './KeystoneRunRankingsTableBase';

function mapKeystoneRunRankingsTableStateToProps(state: any): TKeystoneRunRankingsTablePropsFromState {
  const hashVars = getHashVars();
  return {
    currentRunId: hashVars.runId,
    isMdiManager: state.auth?.features && state.auth.features.indexOf(FeatureFlag.MDI_MANAGER) !== -1,
    siteConfig: state.siteConfig,
    currentFeatures: state.currentFeatures
  };
}

export const KeystoneRunRankingsTable = connect<
  TKeystoneRunRankingsTablePropsFromState,
  {},
  TKeystoneRunRankingsTableOwnProps
>(mapKeystoneRunRankingsTableStateToProps)(KeystoneRunRankingsTableBase as any);
